// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchInput_wrapper__PoyqH","input":"SearchInput_input__oXb+b"};